import "../../common/common_styles.css";
import UploadContent from "../UI/UploadContent/uploadContent";
import Subject from "../CriteriaSubmission/assesmentForm/subject";
import LanguageSelector from "../CriteriaSubmission/languageSelector";
import Grade from "../CriteriaSubmission/assesmentForm/grade";
import { selectAssignmentData, setAssignmentData } from "../../slices/gradingForm";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const WritingAssignmentCriteria = ( ) => {
    const assignmentData = useSelector(selectAssignmentData);

    return (
        <>
            <LanguageSelector />
            <>
                <Subject selectStoreData={selectAssignmentData} setStoreData={setAssignmentData}/>
                <Grade selectStoreData={selectAssignmentData} setStoreData={setAssignmentData}/>
                <UploadContent 
                    textLabel="Describe or upload your writing assignment or writing prompt:"
                    textPlaceholder='Enter and/or upload a description of your writing assignment. Include the source text if applicable.'
                    nameInStore="assignment"
                    selectStoreData={selectAssignmentData}
                    setStoreData={setAssignmentData}
                />
                <br />
                <br />
            </>
        </>
    );
};

export default WritingAssignmentCriteria;
